import { motion } from "framer-motion";
import AnimatedSection from "./AnimatedSection";
import Icon from "./Icon";
import IPhoneMockup from "./IPhoneMockup";
import StoreBadges from "./StoreBadges";
import screenshot from "../assets/Screenshot.png";

function Hero() {
  return (
    <section className="hero-gradient pt-32 pb-20 px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-16">
        {/* Left Content */}
        <div className="flex-1 space-y-8 text-center lg:text-left">
          <AnimatedSection>
            <h1 className="font-headline text-5xl md:text-7xl font-extrabold text-on-background tracking-tight leading-[1.1]">
              Need a{" "}
              <span
                className="font-script text-primary-container"
                style={{ fontSize: "1.15em", lineHeight: 1 }}
              >
                favour
              </span>
              ? <br />
              <span className="text-on-background">Someone nearby is ready.</span>
            </h1>
          </AnimatedSection>

          <AnimatedSection delay={0.15}>
            <p className="text-xl text-on-surface-variant max-w-2xl leading-relaxed">
              SOLID is a premium micro-favour marketplace. From picking up a parcel to watering a plant, experience the pristine exchange of local trust — now live in Maastricht.
            </p>
          </AnimatedSection>

          <AnimatedSection delay={0.3}>
            <div
              id="download"
              className="flex flex-col items-center lg:items-start gap-4 scroll-mt-28"
            >
              <StoreBadges className="justify-center lg:justify-start" />
              <button
                onClick={() => document.getElementById("how-it-works").scrollIntoView({ behavior: "smooth" })}
                className="text-secondary font-bold text-base hover:text-primary transition-colors flex items-center gap-1"
              >
                Learn how it works
                <Icon name="arrow_downward" className="text-lg" />
              </button>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.45}>
            <div className="flex items-center gap-3 justify-center lg:justify-start text-sm font-medium text-secondary">
              <Icon name="verified" className="text-primary" filled />
              Available now on iOS &amp; Android.
            </div>
          </AnimatedSection>
        </div>

        {/* Right - 3D iPhone Mockup */}
        <div className="flex-1 relative w-full max-w-lg lg:max-w-none flex flex-col items-center">
          <IPhoneMockup src={screenshot} alt="SOLID App Interface" />

          {/* Glass floating element below the phone */}
          <motion.div
            className="mt-6 glass-card px-6 py-4 rounded-2xl shadow-lg flex items-center gap-4 w-full max-w-xs"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.9 }}
          >
            <div className="w-10 h-10 rounded-full bg-primary-container/20 flex items-center justify-center text-primary flex-shrink-0">
              <Icon name="verified" />
            </div>
            <div>
              <p className="font-bold text-on-surface text-sm">Favour Secured</p>
              <p className="text-xs text-on-surface-variant">Contract #8829 initialized securely.</p>
            </div>
          </motion.div>

          {/* Background decoration */}
          <div className="absolute -top-20 -right-20 w-80 h-80 bg-primary-container/20 blur-[100px] rounded-full -z-10"></div>
          <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-secondary-container/30 blur-[100px] rounded-full -z-10"></div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
